<template>
  <div style="display: flex">
    <ly-form-item label="查询模式">
      <Select v-model="chaxunmodel" @on-change='changeModel'>
        <Option :value="0" v-if="timeModel1.includes(0)">自选区间</Option>
        <Option :value="1" v-if="timeModel1.includes(1)">按天</Option>
        <Option :value="2" v-if="timeModel1.includes(2)">按月</Option>
        <Option :value="3" v-if="timeModel1.includes(3)">按季度</Option>
        <Option :value="4" v-if="timeModel1.includes(4)">按年</Option>
      </Select>
    </ly-form-item>
    <template v-if="chaxunmodel == 0">
      <Select
        v-model="day"
        @on-change="selectGetDay"
        style="width: 80px; margin-top: 6px"
      >
        <Option v-for="item in dayList" :value="item.value" :key="item.value">{{
          item.label
        }}</Option>
      </Select>
      <DatePicker
        type="date"
        v-model="startTime"
        style="width: 116px"
        :clearable="false"
      ></DatePicker>
      <span style="margin: 4px 4px 0 4px">至</span>
      <DatePicker
        type="date"
        v-model="endTime"
        @on-change="endChange"
        style="width: 116px"
        :clearable="false"
      ></DatePicker>
      <Button
        style="margin-left: 20px; height: 30px"
        @click="lijichaxun()"
        type="primary"
        size="small"
        icon="ios-search"
        >查询</Button
      >
    </template>
    <template v-if="chaxunmodel == 3">
      <DatePicker
        type="year"
        v-model="year"
        style="width: 100px"
        :clearable="false"
      ></DatePicker>
      <Select v-model="jidu" style="width: 120px; margin-top: 6px">
        <Option :value="0">第一季度</Option>
        <Option :value="1">第二季度</Option>
        <Option :value="2">第三季度</Option>
        <Option :value="3">第四季度</Option>
      </Select>
      <Button
        style="margin-left: 20px; height: 30px"
        type="primary"
        size="small"
        icon="ios-search"
        @click="chajidu"
        >查询</Button
      >
    </template>
    <template v-if="chaxunmodel == 2">
      <DatePicker
        type="month"
        v-model="month"
        style="width: 120px"
        :clearable="false"
      ></DatePicker>
      <Button
        style="margin-left: 20px; height: 30px"
        type="primary"
        size="small"
        icon="ios-search"
        @click="searchMonth"
        >查询</Button
      >
    </template>
    <template v-if="chaxunmodel == 1">
      <DatePicker
        type="date"
        v-model="date"
        style="width: 140px"
        :clearable="false"
      ></DatePicker>
      <Button
        style="margin-left: 20px; height: 30px"
        type="primary"
        size="small"
        icon="ios-search"
        @click="searchDay"
        >查询</Button
      >
    </template>
    <template v-if="chaxunmodel == 4">
      <DatePicker
        type="year"
        v-model="year"
        style="width: 120px"
        :clearable="false"
      ></DatePicker>
      <Button
        style="margin-left: 20px; height: 30px"
        type="primary"
        size="small"
        icon="ios-search"
        @click="searchYear"
        >查询</Button
      >
    </template>
  </div>
</template>
<script>
export default {
  props: ["day0", "timeModel"],
  data() {
    return {
      timeModel1: this.timeModel || "0,1,2",
      chaxunmodel: this.timeModel == undefined ? 0 : Number(this.timeModel[0]),
      year: new Date(),
      jidu: parseInt(new Date().getMonth() / 3),
      month: new Date(),
      date: new Date(),
      dayList: [
        {
          value: -3,
          label: "近三天",
        },
        {
          value: -7,
          label: "近七天",
        },
        {
          value: -15,
          label: "近15天",
        },
        {
          value: -30,
          label: "近30天",
        },
        {
          value: 10,
          label: "自定义",
        },
      ],
      day: this.day0 || -7,
      startTime: "",
      endTime: "",
    };
  },
  methods: {
    selectGetDay() {
      var t = this.utils.days(this.day, 0);
      this.startTime = new Date(t.start);
      this.endTime = new Date(t.end);
      this.timeObj = {
        start: this.startTime.getTime(),
        end: this.endTime.getTime(),
      };
      this.$emit("timeObj", this.timeObj);
    },
    lijichaxun() {
      if (
        this.utils.jcTime(this, {
          startTime: this.startTime,
          endTime: this.endTime,
        })
      ) {
        this.timeObj = {
          start: this.startTime.getTime(),
          end: this.endTime.getTime(),
        };
        this.$emit("timeObj", this.timeObj);
      }
    },
    chajidu() {
      var y = this.year.getFullYear();
      var start = new Date(y, this.jidu * 3, 1).getTime();
      var end = new Date(y, this.jidu * 3 + 3, 1).getTime() - 1000;
      this.timeObj = { start, end };
      this.$emit("timeObj", this.timeObj);
    },
    searchMonth() {
      var y = this.month.getFullYear();
      var m = this.month.getMonth();
      var start = new Date(y, m, 1).getTime();
      var end = new Date(y, m + 1, 1).getTime() - 1000;
      this.timeObj = { start, end };
      this.$emit("timeObj", this.timeObj);
    },
    searchDay() {
      var y = this.date.getFullYear();
      var m = this.date.getMonth();
      var d = this.date.getDate();
      var start = new Date(y, m, d).getTime();
      var end = new Date(y, m, d + 1).getTime() - 1000;
      this.timeObj = { start, end };
      this.$emit("timeObj", this.timeObj);
    },
    searchYear() {
      var y = this.month.getFullYear();
      var start = new Date(y, 0, 1).getTime();
      var end = new Date(y + 1, 0, 1).getTime() - 1000;
      this.timeObj = { start, end };
      this.$emit("timeObj", this.timeObj);
    },
    //手动选择结束时间的时候，默认加到当前时间时分秒
    endChange() {
      this.endTime = new Date(this.endTime.getTime() + 86399 * 1000);
      this.endTime;
    },
    //模式转换
    changeModel(v){
      if (v==0) {
        this.selectGetDay(this.day);
      }
    }
  },
  mounted() {
    if (this.timeModel1[0] == "0") {
      this.selectGetDay(this.day);
    } else if (this.timeModel[0] == "1") {
      this.searchDay();
    } else if (this.timeModel[0] == "2") {
      this.searchMonth();
    } else if (this.timeModel[0] == "3") {
      this.chajidu();
    } else if (this.timeModel[0] == "4") {
      this.searchYear();
    }
  },
};
</script>


// WEBPACK FOOTER //
// src/components/common/timeTool.vue